import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, MapPin, Filter, Grid, List, ChevronDown, Briefcase, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardContent, CardFooter, CardHeader } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Checkbox } from '../components/ui/Checkbox';
import { Slider } from '../components/ui/Slider';
import { Avatar } from '../components/ui/Avatar';
import { cn } from '../lib/utils';
const JOBS = [{
  id: 1,
  title: 'Senior Backend Developer',
  company: 'PT Teknologi Indonesia',
  location: 'Jakarta',
  type: 'Full-time',
  salary: 15,
  salaryMax: 20,
  match: 95,
  skills: ['Backend', 'Node.js', 'PostgreSQL'],
  posted: '5 hari lalu',
  experience: 5,
  description: 'Kami mencari Senior Backend Developer berpengalaman untuk bergabung dengan tim engineering kami...'
}, {
  id: 2,
  title: 'Frontend Engineer',
  company: 'PT Digital Solutions',
  location: 'Remote',
  type: 'Full-time',
  salary: 12,
  salaryMax: 18,
  match: 88,
  skills: ['Frontend', 'React', 'TypeScript'],
  posted: '2 hari lalu',
  experience: 3,
  description: 'Bergabunglah dengan tim frontend kami untuk membangun pengalaman pengguna yang luar biasa...'
}, {
  id: 3,
  title: 'DevOps Engineer',
  company: 'Startup Inovasi',
  location: 'Bandung',
  type: 'Kontrak',
  salary: 20,
  salaryMax: 30,
  match: 82,
  skills: ['DevOps', 'Docker', 'Kubernetes'],
  posted: '1 minggu lalu',
  experience: 4,
  description: 'Mencari DevOps Engineer untuk mengelola infrastruktur cloud dan CI/CD pipeline...'
}, {
  id: 4,
  title: 'Full Stack Developer',
  company: 'PT Software House',
  location: 'Jakarta',
  type: 'Full-time',
  salary: 10,
  salaryMax: 15,
  match: 90,
  skills: ['Full Stack', 'Laravel', 'Vue.js'],
  posted: '3 hari lalu',
  experience: 3,
  description: 'Dibutuhkan Full Stack Developer dengan keahlian PHP dan JavaScript modern...'
}, {
  id: 5,
  title: 'Mobile Developer',
  company: 'Tech Company',
  location: 'Surabaya',
  type: 'Freelance',
  salary: 8,
  salaryMax: 12,
  match: 75,
  skills: ['Mobile', 'Flutter', 'Dart'],
  posted: '1 hari lalu',
  experience: 2,
  description: 'Pengembangan aplikasi mobile berbasis proyek menggunakan Flutter framework...'
}, {
  id: 6,
  title: 'Data Scientist',
  company: 'Analytics Corp',
  location: 'Remote',
  type: 'Full-time',
  salary: 25,
  salaryMax: 40,
  match: 85,
  skills: ['Data Science', 'Python', 'Machine Learning'],
  posted: '4 hari lalu',
  experience: 5,
  description: 'Bergabung dengan tim data kami untuk mengembangkan model machine learning...'
}];
export function JobListings() {
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // Filter states
  const [selectedSkills, setSelectedSkills] = useState<string[]>([]);
  const [selectedLocations, setSelectedLocations] = useState<string[]>([]);
  const [selectedJobType, setSelectedJobType] = useState<string>('');
  const [expRange, setExpRange] = useState([0, 20]);
  const [salaryRange, setSalaryRange] = useState([0, 100]);
  // Filter jobs
  const filteredJobs = JOBS.filter(job => {
    const matchesSearch = job.title.toLowerCase().includes(searchQuery.toLowerCase()) || job.company.toLowerCase().includes(searchQuery.toLowerCase()) || job.skills.some(skill => skill.toLowerCase().includes(searchQuery.toLowerCase()));
    const matchesSkills = selectedSkills.length === 0 || job.skills.some(skill => selectedSkills.includes(skill));
    const matchesLocation = selectedLocations.length === 0 || selectedLocations.includes(job.location);
    const matchesJobType = !selectedJobType || job.type === selectedJobType;
    const matchesExperience = job.experience >= expRange[0] && job.experience <= expRange[1];
    const matchesSalary = job.salary >= salaryRange[0] && job.salaryMax <= salaryRange[1];
    return matchesSearch && matchesSkills && matchesLocation && matchesJobType && matchesExperience && matchesSalary;
  });
  const handleSkillToggle = (skill: string) => {
    setSelectedSkills(prev => prev.includes(skill) ? prev.filter(s => s !== skill) : [...prev, skill]);
  };
  const handleLocationToggle = (location: string) => {
    setSelectedLocations(prev => prev.includes(location) ? prev.filter(l => l !== location) : [...prev, location]);
  };
  const handleClearFilters = () => {
    setSelectedSkills([]);
    setSelectedLocations([]);
    setSelectedJobType('');
    setExpRange([0, 20]);
    setSalaryRange([0, 100]);
    setSearchQuery('');
  };
  const FilterSidebar = () => <div className="space-y-8" data-id="element-3517">
      <div className="relative" data-id="element-3518">
        <Input placeholder="Cari lowongan..." className="pl-10" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-3519" />
        <Search className="absolute left-3 top-2.5 h-5 w-5 text-neutral-400" data-id="element-3520" />
      </div>

      <div className="space-y-3" data-id="element-3521">
        <h3 className="text-neutral-900 font-semibold text-sm" data-id="element-3522">Keahlian</h3>
        <div className="space-y-2" data-id="element-3523">
          {['Backend', 'Frontend', 'DevOps', 'Data Science', 'Mobile', 'Full Stack'].map(skill => <label key={skill} className="flex items-center gap-3 cursor-pointer group" data-id="element-3524">
              <input type="checkbox" checked={selectedSkills.includes(skill)} onChange={() => handleSkillToggle(skill)} className="w-4 h-4 rounded border-neutral-300 text-atios-primary focus:ring-atios-primary" data-id="element-3525" />
              <span className="text-sm text-neutral-700 group-hover:text-neutral-900 transition-colors" data-id="element-3526">
                {skill}
              </span>
            </label>)}
        </div>
      </div>

      <div className="space-y-4" data-id="element-3527">
        <div className="flex justify-between items-center" data-id="element-3528">
          <h3 className="text-neutral-900 font-semibold text-sm" data-id="element-3529">Pengalaman</h3>
          <span className="text-xs text-neutral-500" data-id="element-3530">
            {expRange[0]} - {expRange[1]} tahun
          </span>
        </div>
        <Slider min={0} max={20} value={expRange} onChange={setExpRange} data-id="element-3531" />
      </div>

      <div className="space-y-3" data-id="element-3532">
        <h3 className="text-neutral-900 font-semibold text-sm" data-id="element-3533">Lokasi</h3>
        <div className="space-y-2" data-id="element-3534">
          {['Jakarta', 'Bandung', 'Surabaya', 'Remote'].map(loc => <label key={loc} className="flex items-center gap-3 cursor-pointer group" data-id="element-3535">
              <input type="checkbox" checked={selectedLocations.includes(loc)} onChange={() => handleLocationToggle(loc)} className="w-4 h-4 rounded border-neutral-300 text-atios-primary focus:ring-atios-primary" data-id="element-3536" />
              <span className="text-sm text-neutral-700 group-hover:text-neutral-900 transition-colors" data-id="element-3537">
                {loc}
              </span>
            </label>)}
        </div>
      </div>

      <div className="space-y-3" data-id="element-3538">
        <h3 className="text-neutral-900 font-semibold text-sm" data-id="element-3539">
          Jenis Pekerjaan
        </h3>
        <div className="space-y-2" data-id="element-3540">
          {['Full-time', 'Kontrak', 'Freelance', 'Part-time'].map(type => <label key={type} className="flex items-center gap-3 cursor-pointer group" data-id="element-3541">
              <input type="radio" name="jobType" checked={selectedJobType === type} onChange={() => setSelectedJobType(type)} className="w-4 h-4 rounded-full border-neutral-300 text-atios-primary focus:ring-atios-primary" data-id="element-3542" />
              <span className="text-sm text-neutral-700 group-hover:text-neutral-900 transition-colors" data-id="element-3543">
                {type}
              </span>
            </label>)}
        </div>
      </div>

      <div className="space-y-4" data-id="element-3544">
        <div className="flex justify-between items-center" data-id="element-3545">
          <h3 className="text-neutral-900 font-semibold text-sm" data-id="element-3546">
            Gaji (per bulan)
          </h3>
          <span className="text-xs text-neutral-500" data-id="element-3547">
            Rp {salaryRange[0]} juta - Rp {salaryRange[1]} juta
          </span>
        </div>
        <Slider min={0} max={100} value={salaryRange} onChange={setSalaryRange} formatLabel={v => `${v} juta`} data-id="element-3548" />
      </div>

      <div className="space-y-3 pt-4 border-t border-neutral-200" data-id="element-3549">
        <Button fullWidth onClick={handleClearFilters} data-id="element-3550">
          Hapus Filter
        </Button>
      </div>
    </div>;
  return <div className="min-h-screen bg-white" data-id="element-3551">
      <div className="flex" data-id="element-3552">
        {/* Desktop Sidebar */}
        <aside className="hidden lg:block w-[280px] bg-neutral-50 border-r border-neutral-200 min-h-[calc(100vh-64px)] p-6 sticky top-16 h-[calc(100vh-64px)] overflow-y-auto" data-id="element-3553">
          <FilterSidebar data-id="element-3554" />
        </aside>

        {/* Mobile Filter Drawer */}
        {showMobileFilters && <div className="fixed inset-0 z-50 lg:hidden" data-id="element-3555">
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setShowMobileFilters(false)} data-id="element-3556" />
            <div className="absolute right-0 top-0 bottom-0 w-[300px] bg-white p-6 overflow-y-auto shadow-xl" data-id="element-3557">
              <div className="flex justify-between items-center mb-6" data-id="element-3558">
                <h2 className="text-xl font-semibold text-neutral-900" data-id="element-3559">
                  Filter
                </h2>
                <Button variant="ghost" size="icon" onClick={() => setShowMobileFilters(false)} data-id="element-3560">
                  <X className="w-5 h-5" data-id="element-3561" />
                </Button>
              </div>
              <FilterSidebar data-id="element-3562" />
            </div>
          </div>}

        {/* Main Content */}
        <main className="flex-1 p-4 md:p-8 max-w-7xl mx-auto w-full" data-id="element-3563">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-3564">
            <div data-id="element-3565">
              <h1 className="text-3xl font-semibold text-neutral-900 mb-1" data-id="element-3566">
                Lowongan Kerja
              </h1>
              <p className="text-neutral-600" data-id="element-3567">
                {filteredJobs.length} posisi tersedia
              </p>
            </div>

            <div className="flex items-center gap-3 w-full md:w-auto" data-id="element-3568">
              <Button variant="secondary" className="lg:hidden flex-1" onClick={() => setShowMobileFilters(true)} data-id="element-3569">
                <Filter className="w-4 h-4 mr-2" data-id="element-3570" /> Filter
              </Button>

              <div className="flex bg-neutral-100 rounded-lg border border-neutral-200 p-1" data-id="element-3571">
                <button onClick={() => setViewMode('grid')} className={cn('p-2 rounded transition-colors', viewMode === 'grid' ? 'bg-white text-atios-primary shadow-sm' : 'text-neutral-600 hover:text-neutral-900')} data-id="element-3572">
                  <Grid className="w-4 h-4" data-id="element-3573" />
                </button>
                <button onClick={() => setViewMode('list')} className={cn('p-2 rounded transition-colors', viewMode === 'list' ? 'bg-white text-atios-primary shadow-sm' : 'text-neutral-600 hover:text-neutral-900')} data-id="element-3574">
                  <List className="w-4 h-4" data-id="element-3575" />
                </button>
              </div>
            </div>
          </div>

          {filteredJobs.length === 0 ? <div className="text-center py-12" data-id="element-3576">
              <Briefcase className="w-16 h-16 text-neutral-300 mx-auto mb-4" data-id="element-3577" />
              <h3 className="text-lg font-semibold text-neutral-900 mb-2" data-id="element-3578">
                Tidak ada lowongan ditemukan
              </h3>
              <p className="text-neutral-600 mb-4" data-id="element-3579">
                Coba ubah filter atau kata kunci pencarian
              </p>
              <Button onClick={handleClearFilters} data-id="element-3580">Hapus Semua Filter</Button>
            </div> : <div className={cn('grid gap-6', viewMode === 'grid' ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1')} data-id="element-3581">
              {filteredJobs.map(job => <Card key={job.id} className="hover:shadow-md transition-all cursor-pointer" onClick={() => navigate(`/jobs/${job.id}`)} data-id="element-3582">
                  <CardHeader className="flex flex-row gap-4 items-start" data-id="element-3583">
                    <Avatar className="h-12 w-12" fallback={job.company.substring(0, 2)} data-id="element-3584" />
                    <div className="flex-1 min-w-0" data-id="element-3585">
                      <div className="flex justify-between items-start" data-id="element-3586">
                        <h3 className="text-base font-semibold text-neutral-900 truncate pr-2 hover:text-atios-primary transition-colors" data-id="element-3587">
                          {job.title}
                        </h3>
                        <Badge variant={job.match >= 90 ? 'success' : job.match >= 70 ? 'default' : 'warning'} className="shrink-0" data-id="element-3588">
                          {job.match}% Cocok
                        </Badge>
                      </div>
                      <p className="text-atios-primary text-sm hover:underline cursor-pointer" data-id="element-3589">
                        {job.company}
                      </p>
                      <div className="flex items-center gap-4 mt-2 text-xs text-neutral-600" data-id="element-3590">
                        <span className="flex items-center gap-1" data-id="element-3591">
                          <MapPin className="w-3 h-3" data-id="element-3592" /> {job.location}
                        </span>
                        <span className="flex items-center gap-1" data-id="element-3593">
                          <Briefcase className="w-3 h-3" data-id="element-3594" /> {job.type}
                        </span>
                      </div>
                    </div>
                  </CardHeader>

                  <CardContent data-id="element-3595">
                    <div className="mb-4" data-id="element-3596">
                      <span className="text-atios-primary font-semibold" data-id="element-3597">
                        Rp {job.salary} juta - Rp {job.salaryMax} juta
                      </span>
                    </div>
                    <p className="text-neutral-600 text-sm mb-4 line-clamp-2" data-id="element-3598">
                      {job.description}
                    </p>
                    <div className="flex flex-wrap gap-2" data-id="element-3599">
                      {job.skills.map(skill => <Badge key={skill} variant="default" data-id="element-3600">
                          {skill}
                        </Badge>)}
                    </div>
                  </CardContent>

                  <CardFooter className="flex justify-between items-center border-t border-neutral-200 pt-4 mt-2" data-id="element-3601">
                    <span className="text-xs text-neutral-500" data-id="element-3602">
                      {job.posted}
                    </span>
                    <div className="flex gap-2" data-id="element-3603">
                      <Button variant="secondary" size="sm" onClick={e => {
                  e.stopPropagation();
                  navigate(`/jobs/${job.id}`);
                }} data-id="element-3604">
                        Lihat Detail
                      </Button>
                      <Button size="sm" onClick={e => {
                  e.stopPropagation();
                  navigate(`/jobs/${job.id}/apply`);
                }} data-id="element-3605">
                        Lamar
                      </Button>
                    </div>
                  </CardFooter>
                </Card>)}
            </div>}

          {filteredJobs.length > 0 && <div className="mt-12 flex justify-center gap-2" data-id="element-3606">
              <Button variant="secondary" disabled data-id="element-3607">
                Sebelumnya
              </Button>
              {[1, 2, 3].map(page => <Button key={page} variant={page === 1 ? 'primary' : 'secondary'} data-id="element-3608">
                  {page}
                </Button>)}
              <span className="flex items-end px-2 text-neutral-500" data-id="element-3609">...</span>
              <Button variant="secondary" data-id="element-3610">10</Button>
              <Button variant="secondary" data-id="element-3611">Selanjutnya</Button>
            </div>}
        </main>
      </div>
    </div>;
}